export function getTokenEarnedDollarAmount(tokens) {
  // Return the dollar amount for a given amount of received tokens.
  return `$${(tokens * 0.07).toFixed(2)}`;
}

export function getTokenDonationDollarAmount(tokens) {
  // Return the dollar amount for a given amount of tokens when donating.
  return `$${(tokens * 0.1).toFixed(2)}`;
}
